import { doHttp } from '../utils/common'
import { HTTP_TYPE_GET, HTTP_TYPE_POST, CONTENT_TYPE_FORM } from '../utils/config'

/**
 * 新增/编辑
 * @param params
 * @return {*}
 */
export function apiEdit (params) {
  return doHttp('/role/add.action', HTTP_TYPE_POST, params)
}

/**
 * 删除
 * @param id
 * @return {*}
 */
export function apiDelete (id) {
  let params = {
    id
  }
  return doHttp('/role/delete.action', HTTP_TYPE_GET, params)
}

/**
 * 详情
 * @param id
 * @return {*}
 */
export function apiDetail (id) {
  let params = {
    id
  }
  return doHttp('/role/detail.action', HTTP_TYPE_GET, params)
}

/**
 * 列表
 * @param {*} pageIndex
 * @param {*} pageSize
 * @return {*}
 */
export function apiRoleList (pageIndex = 1, pageSize = 20) {
  let params = {
    pageIndex,
    pageSize
  }
  return doHttp('/role/list.action', HTTP_TYPE_GET, params)
}
